var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('memoryshare-stream',{attrs:{"slug":_vm.$route.params.slug,"options":"{\"fluid\": false, \"height\": 300, \"width\": 300, \"playerOnly\": true}"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }